<template>
  <div>
    <b-table striped hover responsive head-variant="dark" class="tablerr" :items="datas" :fields="fields">
        <template #cell(question)="data">
            <span v-html="data.value"></span>
        </template>
        <template #cell(a)="data">
            <span v-html="data.value"></span>
        </template>
        <template #cell(b)="data">
            <span v-html="data.value"></span>
        </template>
        <template #cell(stocker_name)="data">
            <router-link :to="{name : 'questionsfor', params : { identity : data.item.stocker_track }, query : { institution: data.item.institution, category: data.item.category, type : 'stocker', subtype : data.item.category != 'Undergraduate' ? 'subject' : 'course', clearance : clearance, [data.item.category != 'Undergraduate' ? 'subject' : 'course'] :   data.item.category != 'Undergraduate' ? data.item.subject : data.item.course , page : 1, source : 'master'} }">{{ data.value }}</router-link>
        </template>
        <template #cell(subject)="data">
            <router-link :to="{name : 'questionsfor', params : { identity : data.value }, query : { institution: data.item.institution, category: data.item.category, type : 'subject', clearance : clearance, subject : data.item.subject, page : 1, source : 'master'} }">{{ data.value }}</router-link>
        </template>
        <template #cell(course)="data">
            <router-link :to="{name : 'questionsfor', params : { identity : data.value }, query : { institution: data.item.institution, category: data.item.category, type : 'course' , course : data.item.course,  clearance : clearance, page : 1, source : 'master'} }">{{ data.value }}</router-link>
        </template>

    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    datas: Array,
    fields: Array,
  },

  

  mounted() {
    //MathJax.Hub.Typeset()
  },

  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
    };
  },
  methods: {
    showMore() {
      let newend = this.endnum + this.intervalnum;

      if (newend < this.endss) {
        this.endnum = newend;
      } else {
        this.endnum = this.limitnum;
      }
    },
  },

  computed: {
    ...mapState({
      clearance : state => state.loginmaster.details.clearance_level,
    }),
    usedatas() {
      return this.datas.slice(0, this.endnum);
    },
    endss() {
      let end = this.datas.length;
      return end;
    },
  },
};
</script>

<style scoped>
.allrewr {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.fhe {
  background-color: #00377b;
  color: white;
  border-radius: 20px 20px 0px 0px;
  font-weight: bold;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
.tablerr{
    overflow: auto;
    scrollbar-width: thin;
}
</style>
